import { ReactNode } from "react";
import UILoader from "./UILoader";
import { useNavigate } from "react-router-dom";
import { MUIButtonProps, UIIconButton, MUIButton } from "..";

export interface UIButtonProps extends MUIButtonProps {
  isIconButton?: boolean;
  isLoading?: boolean;
  children?: ReactNode;
  innerRef?: React.Ref<HTMLButtonElement>;
  to?: string;
}

export const UIButton = ({ isIconButton = false, isLoading = false, children, ref, innerRef, to, ...props }: UIButtonProps) => {
  const navigate = useNavigate();
  if (isIconButton) {
    return (
      <UIIconButton onClick={() => to && navigate(to)} {...props}>
        {children}
      </UIIconButton>
    );
  }
  return (
    <MUIButton
      ref={innerRef}
      variant="contained"
      color="primary"
      startIcon={isLoading ? <UILoader color="inherit" size={18} /> : undefined}
      onClick={() => to && navigate(to)}
      {...props}
    >
      {children}
    </MUIButton>
  );
};

export default UIButton;
